import React from "react";
import {
  Box,
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

type Order = "asc" | "desc";

export const EnhancedCameraTableHeadAutoPatrol = (props: {
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  numSelected: number;
  rowCount: number;
  showSelection: boolean;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
  allExpanded: boolean;
  setAllExpanded: (value: boolean) => void;
  setExpandedObject: React.Dispatch<
    React.SetStateAction<{ [key: string]: boolean }>
  >;
  saveExpandedObjectAllTrue: () => void;
  saveExpandedObjectAllFalse: () => void;
}) => {
  const {
    onSelectAllClick,
    numSelected,
    rowCount,
    showSelection,
    onRequestSort,
    orderBy,
    order,
    allExpanded,
    setExpandedObject,
    saveExpandedObjectAllTrue,
    saveExpandedObjectAllFalse,
  } = props;

  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {showSelection && (
          <TableCell
            padding="checkbox"
            sx={{
              width: "5%",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          >
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all cameras" }}
            />
          </TableCell>
        )}
        <TableCell
          sx={{
            fontSize: "14px",
            fontFamily: "Mulish",
            fontWeight: "Bold",
            paddingLeft: showSelection ? 1 : 2,
            paddingRight: 1,
            whiteSpace: "nowrap",
            width: showSelection ? "35%" : "40%",
          }}
          align="left"
          sortDirection={orderBy === "camera_name" ? order : false}
        >
          <TableSortLabel
            active={orderBy === "camera_name"}
            direction={orderBy === "camera_name" ? order : "asc"}
            onClick={createSortHandler("camera_name")}
          >
            Camera Name
            {orderBy === "camera_name" ? (
              <Box component="span" sx={visuallyHidden}>
                {order === "desc" ? "sorted Z to A" : "sorted A to Z"}
              </Box>
            ) : null}
          </TableSortLabel>
        </TableCell>
        <TableCell
          sx={{
            fontSize: "14px",
            fontFamily: "Mulish",
            fontWeight: "Bold",
            paddingLeft: 1,
            paddingRight: 1,
            width: "40%",
            whiteSpace: "nowrap",
          }}
          align="left"
        >
          Active Products
        </TableCell>
        <TableCell
          align="right"
          sx={{
            fontFamily: "Mulish",
            fontWeight: "Bold",
            fontSize: "14px",
            paddingLeft: 1,
            paddingRight: 2,
            whiteSpace: "nowrap",
            width: "20%",
          }}
        >
          {!allExpanded ? (
            <OrangeTextButton
              onClick={() => {
                props.setAllExpanded(true);
                setExpandedObject((prev) => {
                  const next = { ...prev };
                  Object.keys(next).forEach((k) => {
                    next[k] = true;
                  });
                  return next;
                });
                saveExpandedObjectAllTrue();
              }}
              text={
                <>
                  <KeyboardArrowDownIcon fontSize="small" />
                  &nbsp;Expand All
                </>
              }
              disabled={false}
            />
          ) : (
            <OrangeTextButton
              onClick={() => {
                props.setAllExpanded(false);
                setExpandedObject((prev) => {
                  const next = { ...prev };
                  Object.keys(next).forEach((k) => {
                    next[k] = false;
                  });
                  return next;
                });
                saveExpandedObjectAllFalse();
              }}
              text={
                <>
                  <KeyboardArrowUpIcon fontSize="small" />
                  &nbsp;Collapse All
                </>
              }
              disabled={false}
            />
          )}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
